import { Card } from "@/app/pwa/components/Card";
import { Match, MatchHeader } from "@/app/pwa/components/match/Match";
import { Match as IMatch } from "@/sources/kicker-amateur/types";
import React from "react";

interface ClubTeamScheduleMatchProps {
  match: IMatch;
  teamId: number;
}

//TODO: unify
export function ClubTeamScheduleMatch({
  match,
  teamId,
}: ClubTeamScheduleMatchProps) {

  return (
    <Card p={false} className="mt-6" id={match.Id?.toString()}>
      
      <MatchHeader match={match} className="px-4 pt-3" />

      <Match className="py-2 mx-4 mb-2 mt-1" match={match} teamId={teamId} showBigIcons />
    </Card>
  );
}
